module.exports = __webpack_public_path__ + "static/media/RI-D1-2.4-073.6570caa0.webp";